import AppApi from "api/App/AppApi";
import AppConstants from "global/constants/AppConstants";
import { Result } from "global/constants/AppType";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { isPaginatedData } from "utils/typeGuards/typeGuards";

const usePickSimModel = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [detail, setDetail] = useState<any>();
  const [plan, setPlan] = useState<any>([]);

  const [resultObject, setResultObject] = useState<Result | null>(null);

  const [totalAmount, setTotalAmount] = useState<number | undefined>(0);
  const [planPrice, setPlanPrice] = useState<number | undefined>(0);
  const [simType, setSimType] = useState<string | undefined>("SIM_VAT_LY");

  const getDetailSim = async (id: string) => {
    try {
      setLoading(true);
      const response = await AppApi.simKitPickDetail(id);

      if (response?.data) {
        let data: any = response?.data;
        setDetail(data);
        setTotalAmount(data?.totalAmount);
        setPlanPrice(data?.planPrice);
      } else {
        setResultObject({
          type: "error",
          message: AppConstants.ERROR_OCCUR,
        });
        navigate(`/order/keep-number`);
      }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const getPlan = async () => {
    try {
      setLoading(true);

      const info = {
        page: 0,
        limit: 100,
      };

      const response = await AppApi.getPackage(info);

      if (response?.data && isPaginatedData(response.data)) {
        const activePlans = response.data.items.filter(
          (plan: any) => plan.status === 0 || plan.status === "ACTIVE",
        );
        setPlan(activePlans);
      }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDetail = (info: any) => {
    navigate(`/detail?id=${info.id}&type=orderDkttb`);
  };

  useEffect(() => {
    if (id) {
      getDetailSim(id);
      getPlan();
    }
  }, [id]);

  return {
    id,
    loading,
    plan,
    detail,
    resultObject,
    planPrice,
    totalAmount,
    simType,
    setSimType,
    setTotalAmount,
    setPlanPrice,
    getDetailSim,
    setResultObject,
    handleDetail,
  };
};

export default usePickSimModel;
